import React from 'react';
import QuickReportRow from './quickReportRow';
import Map from '../../common/mapComponent';

class QuickAddressReport extends React.Component {
    shouldComponentUpdate(nextProps, nextState) {
        return this.props.dataHash !== nextProps.dataHash;
    }

    render() {
        return (this.props.data === undefined || this.props.data === null ? null : this.renderContent(this.props.data));
    }

    renderContent = (data) => {
        return (
            <div className="columns">
                <div className="column is-12-desktop">
                    <table className="table table-report-section">
                            <colgroup>
                                <col width="30%" />
                                <col width="70%" />
                            </colgroup>
                            <tbody>
                                { this.renderAddressData(data) }
                            </tbody>
                    </table>
                </div>
            </div>
        )
    }

    renderAddressData = (data) => {
        return (
            <React.Fragment>
                <QuickReportRow translationKey="Report.QuickAddress.Street" value={data.street} />
                <QuickReportRow translationKey="Report.QuickAddress.City" value={data.city} />
                <QuickReportRow translationKey="Report.QuickAddress.Zip" value={data.zip} />
                <QuickReportRow translationKey="Report.QuickAddress.Country" value={data.country} />
                <QuickReportRow translationKey="Report.QuickAddress.Ruian" value={data.ruianOrRegAdr} />
                <QuickReportRow translationKey="Report.QuickAddress.FlatCount" value={data.flatCount} />
                <tr>
                    <td></td>
                    <td><Map address={data.fullAddress} permanent={true}/></td>
                </tr>
            </React.Fragment>
        )
    }
}

export default QuickAddressReport;